import { useEffect } from "react";
import { allowNextAssetRecovery } from "@/lib/asset-recovery";

export default function PageReady() {
  useEffect(() => {
    // Only a real interaction with a successfully mounted page starts a new
    // recovery incident. Mounting after a reload alone must not reset the
    // guard, or a later failing dependency could create a reload loop.
    const ready = (event: Event) => {
      if (!event.isTrusted) return;
      allowNextAssetRecovery();
      window.removeEventListener("pointerdown", ready, true);
      window.removeEventListener("keydown", ready, true);
    };
    window.addEventListener("pointerdown", ready, { capture: true });
    window.addEventListener("keydown", ready, { capture: true });
    return () => {
      window.removeEventListener("pointerdown", ready, true);
      window.removeEventListener("keydown", ready, true);
    };
  }, []);
  return null;
}
